import { render, staticRenderFns } from "./JoinRequestTab.vue?vue&type=template&id=0abfb9c8"
import script from "./JoinRequestTab.vue?vue&type=script&lang=js"
export * from "./JoinRequestTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports